module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-731-retro-min.74f14ce9.jpg";